import { fetchAuthSession, setUpTOTP } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { QRCode } from 'react-qr-code';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import images from '../../assets/images';
import { companyNameReplace } from '../../utils';

function AuthAppSetup() {
  const navigate = useNavigate();

  const [secretCode, setSecretCode] = useState<string>('');
  const [qrUri, setQrUri] = useState<string>('');

  useEffect(() => {
    const setupTOTP = async () => {
      try {
        const session = await fetchAuthSession();

        const { sharedSecret } = await setUpTOTP();
        setSecretCode(sharedSecret);

        const email = session?.tokens?.idToken?.payload.email;
        const appName = 'InstaVolt';
        const otpAuthUri = `otpauth://totp/${appName}:${email}?secret=${sharedSecret}&issuer=${appName}`;
        setQrUri(otpAuthUri);
      } catch (error) {
        toast.error(error);
      }
    };
    setupTOTP();
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(secretCode);
    toast.success(t('authentication.message.codeCopy'));
  };

  const handleBackBtnClick = () => {
    navigate('/auth/select-auth-option', { replace: true });
  };

  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{companyNameReplace(t('authentication.title'))} </title>
      </Helmet>
      {qrUri && secretCode ? (
        <div className="auth-options-wrapper auth-app-setup-wrapper">
          <div className="auth-options-container auth-app-setup-container">
            <div className="auth-header">
              <div className="auth-icon-container">
                <img src={images.authAppIconSVG} alt="Security" className="auth-icon-image" />
              </div>
              <h1 className="auth-title">{t('authentication.authOptionTitle.authenticatorApp')}</h1>
              <p className="auth-subtitle">{t('authentication.message.authenticatorApp')}</p>
            </div>
            {qrUri && <div className="qr-code-wrapper text-wrap">{<QRCode value={qrUri} size={125} />}</div>}
            <p className="mt-4 auth-subtitle auth-setup-instruction">{t('authentication.message.manualSetup')}</p>
            {secretCode && (
              <div className="secret-code-box">
                <button className="copy-btn" onClick={handleCopy} title="Copy code">
                  <img src={images.copyIconSVG} alt="" />
                </button>
                <p className="secret-code">{secretCode}</p>
              </div>
            )}
            <div className="auth-app-button-wrapper">
              <button
                type="button"
                className="btn btn-primary auth-app-button"
                onClick={() => {
                  navigate('/auth/setup/authenticator/OTP', { replace: true });
                }}
              >
                {t('authentication.button.continue')}
              </button>
              <p className="different-auth-method" onClick={handleBackBtnClick}>
                {t('authentication.button.differentMethod')}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="spinner"></div>
      )}
    </>
  );
}

export default AuthAppSetup;
